<template>
  <div class="pi-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'pi-content',
  data () {
    return {
      title: '',
      groupTop: ''
    };
  },
  methods: {
    goBack () {
      window.history.go(-1);
    }
  },
  mounted () {
  },
  computed: {
  },
  props: {
    className: {
      type: String,
      default: ''
    },
    back: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/less/old/var.less";
.pi-content {
}
</style>
